import Form from 'next/form';

import { Input } from './ui/input';
import { Label } from './ui/label';
import { useFormStatus } from 'react-dom';

export function AuthForm({
  action,
  children,
  origin,
  callbackUrl,
  defaultEmail = '',
}: {
  action: NonNullable<
    string | ((formData: FormData) => void | Promise<void>) | undefined
  >;
  children: React.ReactNode;
  origin: string;
  callbackUrl?: string | null;
  defaultEmail?: string;
}) {
  const { pending } = useFormStatus();

  return (
    <Form
      action={action}
      className="flex flex-col gap-4 px-4 sm:px-16"
    >
      <Input
        id="origin"
        name="origin"
        type="hidden"
        defaultValue={origin}
      />
      {callbackUrl ? (
        <Input
          id="callbackUrl"
          name="callbackUrl"
          type="hidden"
          defaultValue={callbackUrl}
        />
      ) : null}

      <div className="flex flex-col gap-2">
        <Label
          htmlFor="email"
          className="text-zinc-600 font-normal dark:text-zinc-400"
        >
          Email Address
        </Label>

        <Input
          id="email"
          name="email"
          className="bg-muted text-md md:text-sm"
          type="email"
          placeholder="user@acme.com"
          autoComplete="email"
          disabled={pending}
          required
          autoFocus
          defaultValue={defaultEmail}
        />
      </div>

      {children}
    </Form>
  );
}
